<template >
  <md-badge
    
    :md-content="badgeContentLocal"
    md-dense
    class="mr-3 ml-2"
    :class="{ 'moow-badge': badge }"
  >
    <md-avatar @click="handleClick" :class="{ 'medium': size == 'medium', 'small': size == 'small', 'large': size == 'large', 'avatar-container': !flat }">
      <img
      :src="imgSource ? imgSource : avatarPlaceholder"
      alt="Avatar"
    />
    </md-avatar>
    <p v-if="title" style="text-align:center">{{title}}</p>
  </md-badge>
</template>


<script>
// Example usage
//  <moow-button :type="['light', 'outlined', 'flat']" btnText="Testing" icon="edit"></moow-button>

export default {
  props: {
    title: {
      type: String, 
      required: false
    },
    userMid: {
      type: String, 
      required: false
    },
    imgSource: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
    badge: {
      type: [Boolean, String],
      required: false
    },
    badgeContent: {
      type: String, 
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {};
  },
  filters: {},
  computed: {
    badgeContentLocal() {
      if(this.badgeContent) return this.badgeContent
      else return "!" 
    },
    avatarPlaceholder() {
      return require("../../assets/prof-pic-placeholder@2x.png");
    },
  },
  mounted() {},
  created() {},
  methods: {
    handleClick(payload) {
      this.$emit("mClick", payload);
    },
    routeToUser() {
      if(!this.userMID) return
      this.routeTo("user", { id: this.userMID });
    },
    routeTo(where, params) {
      this.$router.push({ name: where, params: params });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/variables.scss";

  .moow-badge .md-badge{
    color:white;
    font-weight: bold;
    background-color: #F76765;
    
  }

  .avatar-container {
    box-shadow:0 1px 4px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 0, 0, 0.1) inset !important;
  }

  .large{
    min-width:80px;
    height: 80px;
  }

</style>



// WEBPACK FOOTER //
// src/components/interface/moowAvatar.vue